import { Injectable } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { AddressModel } from "../models/address.model";
import { InstructorModel } from "../models/instructor.model";
import { ResultModel } from "../models/result.model";
import { map } from 'rxjs/operators';
import { ExamModel } from '../models/exam.model';
import { ExamParticipantModel } from '../models/exam-participant.model';

@Injectable({
  providedIn: "root",
})
export class ExamService extends BaseService {

  listAllForSelect(filter?: {ClassLevelID?: string, ExamTypeID?: string}) {
    if(filter == null || !(filter.ClassLevelID || filter.ExamTypeID)) // variables are null or emty
      return this.httpClient.get<ResultModel<ExamModel[]>>(this.getApiUrl("exams"));
    else
      return this.httpClient.get<ResultModel<ExamModel[]>>(this.getApiUrl("exams?") + this.getQueryString(filter));
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<ExamModel[]>>(this.getApiUrl("exams/list"), formData);
  }

  create(exam: ExamModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl("exams"), exam);
  }

  update(exam: ExamModel) {
    return this.httpClient.put<ResultModel>(this.getApiUrl("exams"), exam);
  }

  get(id: string) {
    return this.httpClient.get<any>(this.getApiUrl("exams/" + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl("exams/" + id));
  }

  downloadResult(id: string, classID:string) {
    if(classID){
      return this.httpClient.get<ResultModel>(this.getApiUrl("exams/result/" + id + "/class/" + classID));
    }
    else{
      return this.httpClient.get<ResultModel>(this.getApiUrl("exams/result/" + id + "/class/"));
    }
    
  }

  
  participantResult(formData?: FormData) {
    return this.httpClient.post<ResultModel<ExamModel[]>>(this.getApiUrl("exams/participant"), formData);
  }

  deleteParticipant(id: string, studentID: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl("exams/participant/" + id + "/student/" + studentID));
  }

  calculateResult(id: string) {
    return this.httpClient.get<ResultModel>(this.getApiUrl("exams/calculate/" + id));
  }


  listAllForStudent(formData?: FormData) {
    return this.httpClient.post<ResultModel<ExamModel[]>>(this.getApiUrl("exams/list-exams"), formData);
  }

  getForStudent(id: string) {
    return this.httpClient.get<any>(this.getApiUrl(`exams/${id}/info`));
  }

  attendForStudent(id: string, bookletIndex: string) {
    return this.httpClient.get<any>(this.getApiUrl(`exams/${id}/attend/${bookletIndex}`));
  }

  finishExamForStudent(examParticipant: ExamParticipantModel) {
    return this.httpClient.post<any>(this.getApiUrl(`exams/finish`), examParticipant);
  }

  saveExamForStudent(examParticipant: ExamParticipantModel) {
    return this.httpClient.post<any>(this.getApiUrl(`exams/save`), examParticipant);
  }

  getResultForStudent(id: string) {
    return this.httpClient.get<any>(this.getApiUrl("exams/studentresult/" + id));
  }

}
